import { PartnerDetail } from '../../../../common/models/search.interface';
import { PreferredPaymentModePayload } from '../../../../common/models/payments.interface';

export interface SharedState {
    ui: {
        partnerPicklist?: {
            loading: boolean;
        };
        preferredPaymentInfo?: {
            loading: boolean;
        };
    };
    data: {
        partnerPicklist?: {
            partnerData: PartnerDetail[];
        };
        preferredPaymentInfo?: PreferredPaymentModePayload;
    };
}

export const initialSharedState: SharedState = {
    ui: {},
    data: {}
};
